"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Post;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _item = _interopRequireDefault(require("./post/item"));

function Post({
  previous,
  next,
  group,
  className,
  iconNext,
  iconPrevious,
  innerNext,
  innerPrevious,
  styleNext,
  stylePrevious
}) {
  if (previous || next) {
    return /*#__PURE__*/_react.default.createElement("nav", {
      className: (0, _classnames.default)("pagination", className),
      role: "navigation",
      "aria-label": "pagination"
    }, previous && /*#__PURE__*/_react.default.createElement(_item.default, {
      group: group,
      slug: previous.slug,
      icon: iconPrevious,
      previous: true,
      title: previous.title,
      style: stylePrevious
    }, innerPrevious), next && /*#__PURE__*/_react.default.createElement(_item.default, {
      group: group,
      slug: next.slug,
      icon: iconNext,
      previous: false,
      title: next.title,
      style: styleNext
    }, innerNext));
  } else {
    return null;
  }
}

Post.propTypes = {
  previous: _propTypes.default.object,
  next: _propTypes.default.object,
  group: _propTypes.default.string,
  className: _propTypes.default.string,
  iconNext: _propTypes.default.string,
  iconPrevious: _propTypes.default.string,
  innerNext: _propTypes.default.any,
  innerPrevious: _propTypes.default.any,
  styleNext: _propTypes.default.object,
  stylePrevious: _propTypes.default.object
};